import React from 'react';
import ReactMarkdown from 'react-markdown';
import Card from '../../components/Card';
import Error from '../../components/Error';
import Loading from '../../components/Loading';
import useFetch from '../../hooks/useFetch';
import Container from '../../layout/container';
import { getActiveLanguageData } from '../../utils/handleLanguage';
import classes from './style.module.scss';

export default function AboutUs() {
  const { response, loading, error } = useFetch('/bitexen-jobs-summary');

  return (
    <Container>
      {loading && <Loading />}
      {error && <Error />}
      {response && (
        <Card className={classes.card}>
          <ReactMarkdown>
            {getActiveLanguageData({
              tr: response.aboutTR,
              en: response.aboutEN,
            })}
          </ReactMarkdown>
        </Card>
      )}
    </Container>
  );
}
